import api from "../api";

export type SplitBookingPayload = {
  bookingId: number;
  splitDate: string;
};

export type SplitBookingResponse = {
  existingBooking: { id: number; startDate: string; endDate: string };
  newBooking: { id: number; startDate: string; endDate: string };
};

export const splitBooking = ({ bookingId, splitDate }: SplitBookingPayload): Promise<SplitBookingResponse> =>
  api({
    url: `booking_module/bookings/${bookingId}/split`,
    method: "put",
    data: {
      splitDate
    }
  });
